const bookmarksInitialState = {
  open: false,
};

export default bookmarksInitialState;